module.exports = __webpack_public_path__ + "static/media/block-6-brisbane.c72b8edc.png";